import { render } from "./ViewAddSourcePath.vue?vue&type=template&id=28c5c9ba"
import script from "./ViewAddSourcePath.vue?vue&type=script&lang=js"
export * from "./ViewAddSourcePath.vue?vue&type=script&lang=js"

import "./ViewAddSourcePath.vue?vue&type=style&index=0&id=28c5c9ba&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.21.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__